// extracted by mini-css-extract-plugin
module.exports = {"h62":"GroupItem_h62__bDoR-"};